/**
 *
 * AppointmentTimeTripBadge
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import ExactTimeIcon from '../../../../assets/v2/ExactTimeIcon';
import { COLORS } from '../../../../theme';
import Badge from '..';

const StyledBadge = styled(Badge)`
  &.MuiChip-root {
    color: ${COLORS.orchidDark};
    background: ${COLORS.orchidLight};
    border-color: ${COLORS.orchid};
  }

  && .MuiSvgIcon-root {
    path {
      fill: ${COLORS.orchid};
    }
  }
`;

function AppointmentTimeTripBadge(props) {
  return (
    <StyledBadge
      icon={<ExactTimeIcon />}
      size="iconLarge"
      variant="outlined"
      {...props}
    />
  );
}

export default memo(AppointmentTimeTripBadge);
